import { defineQuery } from 'next-sanity'

export const careersMarqueeBlockFields = `
  _id,
  _type,
  textRows[]{
    textRow
  }
`

export const CAREERS_MARQUEE_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-marquee-block"][0]{
    ${careersMarqueeBlockFields}
  }
`)
